module.exports = __webpack_public_path__ + "img/instagram_gray.4af6b48a.svg";